import React, { useEffect } from 'react'
import './ECatalog.scss'

import Header from '../../../components/Arabic/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Arabic/PageTitle/PageTitle'
import Footer from '../../../components/Arabic/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import EcatalogContent from '../../../components/Arabic/EcatalogContect/EcatalogContent'

export default function ECatalog() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])
  
  return (
    <div>
      <Header page={'ecatalog'} />
      <UnderHeader className={'ecatalog'} />
      <PageTitle mainTitle={'البريد التسويقي'} page={'البريد التسويقي'} />
      <EcatalogContent />
      <LogoPartner />
      <Footer />
    </div>
  )
}
